import React, { useRef } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { NavButton } from './NavButton';

interface ScrollingSideNavProps {
  navOptions: { id: string; name: string }[];
  activeSection: string;
  scrollerPosition: number;
  scrollToSection: (section: string) => void;
}

export interface NavItem {
  id: string;
  name: string;
}

const ScrollingSideNav = ({
  navOptions,
  activeSection,
  scrollerPosition,
  scrollToSection,
}: ScrollingSideNavProps) => {
  const navRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<HTMLDivElement>(null);
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Nav,
  });

  const handleNavClick = (section: string) => {
    scrollToSection(section);
    trackEvent(click({ clickTarget: ClickTarget.SideNavItem, clickText: section }));
  };

  return (
    <nav
      ref={navRef}
      className="sticky top-88 border-0 border-l-[5px] border-solid border-grayscale-beige"
    >
      <div
        ref={scrollerRef}
        className="absolute -left-[5px] top-0 h-24 w-[5px] -translate-x-[5px] bg-primary-magenta transition-transform"
        style={{ transform: `translateY(${scrollerPosition}px)` }}
      />
      <div className="flex flex-col gap-24">
        {navOptions.map((navItem) => (
          <NavButton
            key={navItem.id}
            id={navItem.id}
            name={navItem.name}
            isActive={navItem.id === activeSection}
            onClick={handleNavClick}
          />
        ))}
      </div>
    </nav>
  );
};

export default ScrollingSideNav;
